import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { ActionButtonDirective } from '@bizzdesign/shared/directives';
import { SharedI18nModule } from '@bizzdesign/shared/i18n';
import { type ActionButton } from '@bizzdesign/shared/models';
import { TranslateActionButtonPipe } from '@bizzdesign/shared/pipes';
import { type SearchScope } from '@bizzdesign/sdk-search';
import { ButtonModule } from 'primeng/button';

/**
 * A link on a search tab empty state that jumps to another scope's tab.
 *
 * @property labelKey - Translation key of the link label.
 * @property scope - The search scope whose tab the link navigates to.
 */
export type SearchTabEmptyStateLink = {
  labelKey: string;
  scope: SearchScope;
};

@Component({
  selector: 'bd-search-tab-empty-state',
  imports: [
    AsyncPipe,
    SharedI18nModule,
    ButtonModule,
    ActionButtonDirective,
    TranslateActionButtonPipe,
  ],
  templateUrl: './search-tab-empty-state.component.html',
  styleUrl: './search-tab-empty-state.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchTabEmptyStateComponent {
  titleKey = input.required<string>();
  descriptionKey = input.required<string>();
  links = input<SearchTabEmptyStateLink[]>([]);
  actionButton = input<ActionButton | undefined>(undefined);

  scopeSelected = output<SearchScope>();
}
